import {
  getToken,
  setToken,
  removeToken
} from "./token";
import {
  getMobile,
  redux
} from './index'
import tools from '@/utils/tools';
import promise from 'es6-promise'
import Axios, { Cancel } from "axios"
// import qs from 'qs'
import store from './store' //使用vuex状态管理
// import router from '../router' //路由
import Bus from "@/assets/js/bus";
import Raven from "raven-js";

// 判断是否在 C 端
const webViewClientC = window.navigator.userAgent.indexOf("hxAx_C") > -1;

promise.polyfill();
const server = Axios.create({
  // baseURL: process.env.BASE_API,
  timeout: 10000
});
// console.log('navigator', navigator)
// console.log('____________+++', getMobile())
server.defaults.headers.post.Accept = '*/*'

server.interceptors.request.use(config => {
  let token = getToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
    config.headers['ssoToken'] = token;
  }
  config.headers['Content-Type'] = 'application/json';
  config.headers['appChannel'] = 'h5';
  config.headers['appVersion'] = localStorage.getItem("AppVersion");
  config.headers['operationSystem'] = getMobile().os;
  config.headers['brand'] = getMobile().brand;
  config.headers['model'] = getMobile().model;
  // 给请求添加权限标示
  config.headers['PTT'] = webViewClientC ? 'm314' : 'm178';

  if (config.headers.dataType !== "xml") {
    config.data = JSON.stringify(config.data);
  }
  return config
}, error => {

});
server.interceptors.response.use(res => {
  if (!res || !res.data) return {}
  if ([1091005, 1091006, 2221101, 1231104].indexOf(res.data.errorCode) > -1) {
    // TODO B端登录请注释
    // removeToken();
    // store.commit('SET_LOG_IN_STATIC', false);
    // res.data = {
    //   'errorCode': -999,
    //   'errorStr': "登录信息失效,请退出重新登录",
    //   'results': {}
    // };
    // setTimeout(() => {
    //   Bus.$emit("outData", () => { });
    // }, 2000)
  } else {
    if (res.data.token && res.data.token !== getToken()) {
      setToken(res.data.token);
      store.commit('SET_LOG_IN_STATIC', true)
    }
    // 非登录报错，上报sentry；
    // if (res.data.errorCode){
    //   try {
    //     Raven.captureException(
    //       {
    //         Authorization: res.config.headers.Authorization,
    //         url: res.config.url,
    //         method: res.config.method,
    //         reqdata: res.config.data,
    //         resdata: res.data
    //       },
    //       {
    //         level: "error",
    //         logger: "http exception"
    //       }
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
      
  }
  // 如果为undefined，处理为对象，减少报错
  return res.data || {}
  //设置vuex状态
}, (error) => {
  // console.dir(error)
  // console.log('----------')
  // 加上报错处理，否则会走then
  if (redux(error, ['constructor', 'name']) === 'Cancel' || redux(error, ['__CANCEL__']) || error instanceof Cancel) {
    return Promise.reject(error)
  }
  tools.showToast('网络异常！<br/>请检查系统版本或网络环境', 2100);
  try {
    Raven.captureException(error, {
      level: "warning",
      logger: "httpError exception"
    });
  } catch (error) {
    console.log(error);
  }
  return Promise.reject(error || {})
});

export default server
